import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PaymentDefinitionComponent } from "./payment-definition.component";

const routes: Routes = [
    {
        path: '',
        component: PaymentDefinitionComponent
    }
]

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class PaymentDefinitionRoutingModule { }
